export function toTitleCase(value: string) {
  const words = value.split(" ");
  return words.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
}
